import PreferenceCentre from "./PreferenceCentre";

export const preferenceCentre = {
    init: () => {
        const forms = document.querySelectorAll(".sd-preference-centre");
        [...forms].forEach((form) => new PreferenceCentre(form));
    },
};

export default preferenceCentre;
